import UserTabs from "./user-tabs";

export default UserTabs;